/*
 * Custom-name pairing: keeps each personalized bag locked to its own name-print
 * charge via a shared per-pair _Order_ID. Removing either line removes the whole
 * pair, and any charge line left without its bag is auto-removed so a customer
 * can never check out with a name charge on its own.
 */
(function () {
  'use strict';
  if (window.__pedalNamePairingBound) return;
  window.__pedalNamePairingBound = true;

  var CHARGE_HANDLES = ['custom-name', 'custom-text'];
  var UPGRADE_HANDLE = 'pro-bundle-upgrade';
  var BOOK_VARIANT_ID = 40066064318625;
  var SCOTTSDALE_PRODUCT_ID = 9430747971819;
  var SCOTTSDALE_CALENDAR_ID = 49342972854507;
  var BLACK_CALENDAR_ID = 47304320385259;
  var IB_UPGRADE_HANDLE = 'insider-bundle-upgrade';
  var IB_TEE_PRODUCT_ID = 9820087124203;
  var IB_BOTTLES_HANDLE = 'insider-bundle-water-bottles';
  var IB_BOOK_PRODUCT_ID = 6767175499937;
  var MAX_RESTORE_TRIES = 2;
  var IB_ONE_MARK = '_ibb_one_per_order';
  var IB_CLAIMED_MARK = '_ibb_package_claimed';
  var PACKAGE_VIEW = '/cart?view=insider-package';
  var MAX_VIEW_TRIES = 2;
  var packageClaimed = null;
  var viewTries = 0;
  var restoreTries = {};
  var demoted = {};
  var removing = false;

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function changeQty(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
  }

  function orderIdOf(item) {
    return (item.properties && item.properties['_Order_ID']) || null;
  }

  function bundleIdOf(item) {
    return (item.properties && item.properties['_pro_bundle']) || null;
  }

  function ibIdOf(item) {
    return (item.properties && item.properties['_insider_bundle']) || null;
  }

  function isCharge(item) {
    return CHARGE_HANDLES.indexOf(item.handle) !== -1;
  }

  function removeKeysSequentially(keys) {
    var chain = Promise.resolve();
    keys.forEach(function (k) { chain = chain.then(function () { return changeQty(k, 0); }); });
    return chain;
  }

  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('restore failed');
      return r;
    });
  }

  function refreshUI() {
    return getCart().then(function (cart) {
      var sub = document.querySelector('[data-subtotal]');
      if (sub && window.theme && theme.Currency) {
        sub.innerHTML = theme.Currency.formatMoney(cart.total_price, theme.settings.moneyFormat);
      }
      var count = document.querySelector('[data-cart-count], .cart-count, .cart__count');
      if (count) count.textContent = cart.item_count;
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      document.dispatchEvent(new CustomEvent('cart:build'));
      return cart;
    });
  }

  window.PedalPairedRemove = function (btn) {
    var orderId = btn.getAttribute('data-order-id') || '';
    var lineKey = btn.getAttribute('data-line-key') || '';
    var rowEl = btn.closest && btn.closest('[data-key]');

    removing = true;
    getCart()
      .then(function (cart) {
        var keys = [];
        cart.items.forEach(function (it) {
          if (orderId && (orderIdOf(it) === orderId || bundleIdOf(it) === orderId || ibIdOf(it) === orderId)) keys.push(it.key);
        });
        if (!keys.length && lineKey) keys.push(lineKey);
        return removeKeysSequentially(keys);
      })
      .then(function () {
        if (rowEl) rowEl.remove();
        removing = false;
        return refreshUI();
      })
      .catch(function (err) { removing = false; console.error('[PedalPairedRemove]', err); });
  };

  function bundlePlan(cart) {
    var groups = {};
    cart.items.forEach(function (it) {
      var b = bundleIdOf(it);
      if (!b) return;
      (groups[b] = groups[b] || []).push(it);
    });
    var remove = [];
    var restore = [];
    Object.keys(groups).forEach(function (id) {
      var bag = null;
      var upgrade = null;
      var free = [];
      groups[id].forEach(function (it) {
        if (it.handle === UPGRADE_HANDLE) upgrade = it;
        else if (orderIdOf(it) === id) bag = it;
        else free.push(it);
      });
      if (!bag) {
        groups[id].forEach(function (it) { remove.push(it.key); });
        return;
      }
      if (!upgrade) {
        free.forEach(function (it) { remove.push(it.key); });
        return;
      }
      var hasBook = free.some(function (it) { return Number(it.variant_id) === BOOK_VARIANT_ID; });
      var hasCalendar = free.some(function (it) { return Number(it.variant_id) !== BOOK_VARIANT_ID; });
      var missing = [];
      if (!hasBook) missing.push(BOOK_VARIANT_ID);
      if (!hasCalendar) {
        missing.push(Number(bag.product_id) === SCOTTSDALE_PRODUCT_ID ? SCOTTSDALE_CALENDAR_ID : BLACK_CALENDAR_ID);
      }
      if (missing.length && (restoreTries[id] || 0) < MAX_RESTORE_TRIES) {
        restoreTries[id] = (restoreTries[id] || 0) + 1;
        missing.forEach(function (vid) {
          restore.push({ id: vid, quantity: 1, properties: { _pro_bundle: id } });
        });
      }
    });
    return { remove: remove, restore: restore };
  }

  function plainProps(props) {
    var out = {};
    var src = props || {};
    for (var k in src) {
      if (Object.prototype.hasOwnProperty.call(src, k) && k !== 'Custom Name' && k !== '_Order_ID' && k !== '_insider_bundle') out[k] = src[k];
    }
    return out;
  }

  function ibStamp(id) {
    var m = /^IB-(\d+)-/.exec(String(id));
    return m ? Number(m[1]) : null;
  }

  function ibOlder(a, b) {
    var sa = ibStamp(a);
    var sb = ibStamp(b);
    if (sa !== null && sb !== null && sa !== sb) return sa < sb;
    if (sa !== null && sb === null) return true;
    if (sa === null && sb !== null) return false;
    return String(a) < String(b);
  }

  function ibUpgradeProps(list) {
    for (var i = 0; i < list.length; i++) {
      if (list[i].handle === IB_UPGRADE_HANDLE) return list[i].properties || {};
    }
    return {};
  }

  function ibRole(it, id, upProps) {
    if (it.handle === IB_UPGRADE_HANDLE) return 'upgrade';
    if (orderIdOf(it) === id) return 'bag';
    if (Number(it.product_id) === IB_TEE_PRODUCT_ID) return 'tee';
    if (upProps && upProps._ib_tee && String(it.variant_id) === String(upProps._ib_tee)) return 'tee';
    if (it.handle === IB_BOTTLES_HANDLE) return 'bottles';
    if (Number(it.product_id) === IB_BOOK_PRODUCT_ID) return 'book';
    return 'calendar';
  }

  function ibBookOff() {
    var marks = document.querySelectorAll ? document.querySelectorAll('[data-ib-book-on]') : [];
    for (var i = 0; i < marks.length; i++) {
      if (marks[i].getAttribute('data-ib-book-on') === '0') return true;
    }
    return false;
  }

  function hasTwin(cart, bag, props) {
    var want = JSON.stringify(props);
    return cart.items.some(function (it) {
      return it.key !== bag.key && Number(it.variant_id) === Number(bag.variant_id) && JSON.stringify(it.properties || {}) === want;
    });
  }

  function customerId() {
    try {
      if (window.__st && window.__st.cid) return window.__st.cid;
      var sa = window.ShopifyAnalytics;
      if (sa && sa.meta && sa.meta.page && sa.meta.page.customerId) return sa.meta.page.customerId;
    } catch (e) {}
    return null;
  }

  function readPackage() {
    if (packageClaimed !== null) return Promise.resolve(packageClaimed);
    if (viewTries >= MAX_VIEW_TRIES) return Promise.resolve(false);
    viewTries += 1;
    return fetch(PACKAGE_VIEW, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) return false;
        return r.text().then(function (t) {
          packageClaimed = JSON.parse(t).claimed === true;
          return packageClaimed;
        });
      })
      .catch(function () { return false; });
  }

  function ibGroups(cart) {
    var groups = {};
    cart.items.forEach(function (it) {
      var b = ibIdOf(it);
      if (!b) return;
      (groups[b] = groups[b] || []).push(it);
    });
    var info = {};
    var complete = [];
    Object.keys(groups).forEach(function (id) {
      var roles = { bag: null, upgrade: null, tee: null, calendar: null, bottles: null, book: null };
      var free = [];
      var extra = [];
      var extraUp = [];
      var upProps = ibUpgradeProps(groups[id]);
      groups[id].forEach(function (it) {
        var r = ibRole(it, id, upProps);
        var isFree = r !== 'bag' && r !== 'upgrade';
        if (roles[r]) {
          if (isFree) extra.push(it);
          else if (r === 'upgrade') extraUp.push(it);
          return;
        }
        roles[r] = it;
        if (isFree) free.push(it);
      });
      info[id] = { roles: roles, free: free, extra: extra, extraUp: extraUp };
      if (roles.bag && roles.upgrade) complete.push(id);
    });
    return { groups: groups, info: info, complete: complete };
  }

  function insiderPlan(cart, claimed) {
    var g = ibGroups(cart);
    var groups = g.groups;
    var info = g.info;
    var complete = g.complete;
    var remove = [];
    var restore = [];
    var fix = [];
    var swaps = [];
    var kept = null;
    complete.forEach(function (id) {
      if (kept === null || ibOlder(id, kept)) kept = id;
    });
    if (claimed) kept = null;
    Object.keys(groups).forEach(function (id) {
      var roles = info[id].roles;
      var free = info[id].free;
      var extra = info[id].extra;
      var extraUp = info[id].extraUp;
      if (!roles.bag) {
        groups[id].forEach(function (it) { remove.push(it.key); });
        return;
      }
      if (!roles.upgrade) {
        free.concat(extra).forEach(function (it) { remove.push(it.key); });
        if ((restoreTries[id] || 0) < MAX_RESTORE_TRIES) {
          restoreTries[id] = (restoreTries[id] || 0) + 1;
          var props = plainProps(roles.bag.properties);
          if (demoted[id]) props[demoted[id]] = '1';
          swaps.push({
            add: { id: roles.bag.variant_id, quantity: roles.bag.quantity, properties: props },
            removeKey: roles.bag.key,
            skipAdd: hasTwin(cart, roles.bag, props)
          });
        }
        return;
      }
      if (id !== kept) {
        demoted[id] = claimed ? IB_CLAIMED_MARK : IB_ONE_MARK;
        [roles.upgrade].concat(free, extra, extraUp).forEach(function (it) { remove.push(it.key); });
        if ((restoreTries[id] || 0) < MAX_RESTORE_TRIES) {
          restoreTries[id] = (restoreTries[id] || 0) + 1;
          var dprops = plainProps(roles.bag.properties);
          dprops[demoted[id]] = '1';
          swaps.push({
            add: { id: roles.bag.variant_id, quantity: roles.bag.quantity, properties: dprops },
            removeKey: roles.bag.key,
            skipAdd: hasTwin(cart, roles.bag, dprops)
          });
        }
        return;
      }
      extra.concat(extraUp).forEach(function (it) { remove.push(it.key); });
      var bookOff = ibBookOff();
      if (bookOff && roles.book) {
        remove.push(roles.book.key);
        roles.book = null;
      }
      var p = roles.upgrade.properties || {};
      var missing = [];
      var over = [];
      [['tee', p._ib_tee], ['calendar', p._ib_cal], ['bottles', p._ib_bot], ['book', bookOff ? null : p._ib_book]].forEach(function (w) {
        var have = roles[w[0]];
        if (!have && w[1]) missing.push(Number(w[1]));
        else if (have && Number(have.quantity) > 1) over.push(have.key);
      });
      if (Number(roles.upgrade.quantity) > 1) over.push(roles.upgrade.key);
      if ((missing.length || over.length) && (restoreTries[id] || 0) < MAX_RESTORE_TRIES) {
        restoreTries[id] = (restoreTries[id] || 0) + 1;
        missing.forEach(function (vid) {
          restore.push({ id: vid, quantity: 1, properties: { _insider_bundle: id } });
        });
        over.forEach(function (k) { fix.push(k); });
      }
    });
    return { remove: remove, restore: restore, fix: fix, swaps: swaps };
  }

  var healing = false;
  function healOrphanCharges() {
    if (healing || removing) return;
    healing = true;
    getCart()
      .then(function (cart) {
        if (customerId() && ibGroups(cart).complete.length) {
          return readPackage().then(function (c) { return [cart, c]; });
        }
        return [cart, false];
      })
      .then(function (pair) {
        var cart = pair[0];
        var claimed = pair[1];
        var bagOrderIds = {};
        cart.items.forEach(function (it) {
          if (isCharge(it)) return;
          var o = orderIdOf(it);
          if (o) bagOrderIds[o] = true;
        });
        var orphans = cart.items.filter(function (it) {
          return isCharge(it) && orderIdOf(it) && !bagOrderIds[orderIdOf(it)];
        });
        var plan = bundlePlan(cart);
        var ib = insiderPlan(cart, claimed);
        var keys = [];
        orphans.map(function (it) { return it.key; }).concat(plan.remove, ib.remove).forEach(function (k) {
          if (keys.indexOf(k) === -1) keys.push(k);
        });
        var restore = plan.restore.concat(ib.restore);
        var fix = ib.fix.filter(function (k) { return keys.indexOf(k) === -1; });
        var swaps = ib.swaps;
        if (!keys.length && !restore.length && !fix.length && !swaps.length) { healing = false; return null; }
        var chain = Promise.resolve();
        swaps.forEach(function (sw) {
          chain = chain.then(function () {
            if (sw.skipAdd) return changeQty(sw.removeKey, 0);
            return addItems([sw.add]).then(function () { return changeQty(sw.removeKey, 0); }, function () { return null; });
          });
        });
        if (keys.length) {
          chain = chain.then(function () { return removeKeysSequentially(keys); });
        }
        fix.forEach(function (k) {
          chain = chain.then(function () { return changeQty(k, 1); });
        });
        if (restore.length) {
          chain = chain.then(function () { return addItems(restore); });
        }
        return chain
          .then(refreshUI)
          .then(function () { healing = false; });
      })
      .catch(function () { healing = false; });
  }

  document.addEventListener('cart:updated', function () { setTimeout(healOrphanCharges, 300); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', healOrphanCharges);
  } else {
    healOrphanCharges();
  }
})();
